import React from "react";

const InstaIframe = () => {
  return (
  
    <iframe src=" https://instagram.demobw.live/khandiamonds/" frameborder="0" width="100%"
        class="insta-iframe" title="insta"></iframe>
  );
};

export default InstaIframe;
